import { render, staticRenderFns } from "./PaymentTranzilaInputs.vue?vue&type=template&id=7dae0e22&"
import script from "./PaymentTranzilaInputs.vue?vue&type=script&lang=ts&"
export * from "./PaymentTranzilaInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports